export default "__VITE_ASSET__d09fd716__"